/**
 * Pending Subscription Events API wrapper
 *
 * JSON endpoint: /api/v1/pending-subscription-events
 * GET /api/v1/pending-subscription-events?pending_id={id} - Get pending subscription events by pending_id
 * GET /api/v1/pending-subscription-events?pending_id={id}&event_type={type} - Get pending subscription events with type filter
 */

import { api } from "../common/utils"
import { PENDING_SUBSCRIPTION_EVENTS_ENDPOINT } from "../common/constants"
import { PendingSubscriptionEventsGetResponse, APIError } from "../types"

const pendingSubscriptionEvents = {
  get: async (
    pendingId: number,
    eventType?: string
  ): Promise<PendingSubscriptionEventsGetResponse | APIError> => {
    if (!pendingId) {
      throw new Error("pending_id is required")
    }

    const params: { pending_id: number; event_type?: string } = {
      pending_id: pendingId
    }

    if (eventType) {
      params.event_type = eventType
    }

    const { data } = await api.get<PendingSubscriptionEventsGetResponse>(
      PENDING_SUBSCRIPTION_EVENTS_ENDPOINT,
      { params }
    )
    return data
  }
}

export default pendingSubscriptionEvents
